export default {"src":"/_next/static/media/c_logo_ec9cd5acb4.05de1db7.svg","height":160,"width":320,"blurWidth":0,"blurHeight":0};